"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var Button_vue_1 = require("@/client/components/common/Button.vue");
exports.default = vue_1.default.extend({
    name: 'SelectAmount',
    components: {
        Button: Button_vue_1.default,
    },
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            amount: this.playerinput.maxByDefault ? String(this.playerinput.max) : String(this.playerinput.min),
        };
    },
    methods: {
        saveData: function () {
            this.onsave([[String(parseInt(this.amount))]]);
        },
        setMaxValue: function () {
            this.amount = String(this.playerinput.max);
        },
    },
});
